export enum ADMIN_LIST_COLUMNS_VALUES {
  NAME = "name",
  DNI = "dni",
  EMAIL = "email",
  SECRETARY = "secretary",
  CREATED_AT = "createdAt",
  STATUS = "status",
  ACTIONS = "actions"
}

export const ADMIN_LIST_COLUMNS = [
  ADMIN_LIST_COLUMNS_VALUES.NAME,
  ADMIN_LIST_COLUMNS_VALUES.DNI,
  ADMIN_LIST_COLUMNS_VALUES.EMAIL,
  ADMIN_LIST_COLUMNS_VALUES.SECRETARY,
  ADMIN_LIST_COLUMNS_VALUES.CREATED_AT,
  ADMIN_LIST_COLUMNS_VALUES.STATUS,
  ADMIN_LIST_COLUMNS_VALUES.ACTIONS
];
